import React from 'react';

import WikiBoxInfoBoxLinkItem from './WikiBoxInfoBoxLinkItem';
import WikiBoxInfoBoxLinkRichItem from './WikiBoxInfoBoxLinkRichItem';

type EntityInfoBoxListItemProps = {
    label: string;
    value: {
        display: string;
        links: string[];
        type: string;
    };
    openInNewTab: boolean;
    encryptionDetails: EncryptionDetailsType;
};
export default function WikiBoxInfoBoxListItem({
    label,
    value,
    openInNewTab,
    encryptionDetails,
}): React.ReactElement<EntityInfoBoxListItemProps> {
    return (
        <>
            {value.values.map((item, i) => {
                if (item.type === 'link') {
                    return (
                        <div datatype="link" className="wikiBox__list-item" key={i}>
                            <WikiBoxInfoBoxLinkItem
                                label={item.display.replace(/&nbsp;/gi, ' ')}
                                url={value.url}
                                encryptionDetails={encryptionDetails}
                                dataType="link"
                            />
                        </div>
                    );
                }
                return (
                    <WikiBoxInfoBoxLinkRichItem
                        key={i}
                        label={item.display}
                        links={value.links}
                        className="wikiBox__list-item"
                        openInNewTab={openInNewTab}
                        encryptionDetails={encryptionDetails}
                        containerType="span"
                    />
                );
            })}
        </>
    );
}
